import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { LocalStorage } from 'ngx-store';
import { formatDate } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { saveAs } from 'file-saver';
import { ImageResult } from 'ngx-image2dataurl';

//Model
import { RepairRequest, DamageReport,RepairRequestChange, Repair,CancelPairing } from './../../../model/maintenance.model';
import { FileExport } from '../../../model/exporter.model';
import { Task } from './../../../model/tasks.model';
import { Url } from '../../../model/users.model';
import { ThemeSetting } from '../../../model/users.model';

//Service
import { ExportService } from '../../../services/exporter.service';
import { MaintenanceService } from './../../../services/maintenance.service';
import { FilesService } from './../../../services/files.service';
import { TaskService } from './../../../services/tasks.service';

@Component({
  selector: 'app-rndreport',
  templateUrl: './rndreport.component.html',
  styleUrls: ['./rndreport.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [MaintenanceService, FilesService, TaskService]
})


export class RnDReportComponent implements OnInit {
  @LocalStorage() url!: Url;
  @LocalStorage() themeSettings: ThemeSetting;

  public fileStoragePath = this.url.fileStorage;

  request_rows = [];
  damage_rows = [];

  selected2 = [];
  selected3 = [];
  selected4 = [];
  temp = [];

  drivers = [];
  fleet = [];
  ratings = [];
  providers = [];
  repair_request_statuses = [];
  rrq_status = [];
  report_statuses = [];
  showSidebar: boolean = true;
  showSidebar2: boolean = true;
  fullRR_Rows = [];
  fullRC_Rows = [];
  selectedRR = [];
  selectedRC = [];

  showFilters2: boolean = false;
  filterDriver: string = '';
  filterDescription: string = '';

  public repairRequestForm: FormGroup;
  public repairRequestFormChanges: FormGroup;
  public damageReportForm: FormGroup;
  public cancelRequestPairingForm: FormGroup;
  public repairForm: FormGroup;
  public modalRef: NgbModalRef;
  public imageFiles : any[];

  public drp: any;
  public rrp: any;

  public repairRequest: RepairRequest;
  public repairRequestChanges: RepairRequestChange;
  public damageReport: DamageReport;
  public cancelRequestPairing: CancelPairing;
  public repair: Repair;
  public isEditMode: boolean = false;


  loadingIndicator: boolean = true;
  reorderable: boolean = true;

  public prefixRepairRequest: string = "repairrequest";
  public prefixDamageReport: string = "report";
  public prefixRepair :string = "repair";

  public title: string;
  public objToDelete: any;
  public fileToDelete: string;

  public objToCancel: any;

  public frmFile: any;
  public fileExists: boolean;
  public fileRemove: boolean;
  public oldFile: string;
  public driver_id: any;
  public p: any;

  public tasksByRepairRequestId: Task[];
  public tasksByDamageReportId: Task[];
  public task: Task;
  public repairRequestId: number;
  public damageReportId: number;
  public caller: string = '';
  public modalCaller: string;

  loading_indicator2: boolean = true;
  loading_indicator3: boolean = true;
  loading_indicator4: boolean = true;

  public prefix_fleet = "fleetdetails";

  showDate: boolean = true;
  showRego: boolean = true;
  showFleetType: boolean = true;
  showDescription: boolean = true;
  showFile: boolean = true;
  filterStatus: string = '';

  showRequestDate: boolean = true;
  showRequestRego: boolean = true;
  showRequestFleetType: boolean = true;
  showRequestDescription: boolean = true;
  showRequestFile: boolean = true;

  showPairingRequestID: boolean = true;
  showPairingDesc: boolean = true;
  showPairingDriver: boolean = true;
  showPairingRating: boolean =true;
  showPairingStatus: boolean =true;
  showRepairConsolidated: boolean = true;

  public exp_excel: FileExport;
  public exp_pdf: FileExport;
  formatted_list: any;
  spinner: boolean = false;

  selectCancelRequests=0;

  @Input() requests: RepairRequestChange[];
  @Input() damages: DamageReport[];
  @Input() parent: string;
  @Input() fleet_id: number;
  @Output() refreshData: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modalRepairRequest', { static: false }) modalRepairRequest: TemplateRef<any>;
  @ViewChild('modalDamageReport', { static: false }) modalDamageReport: TemplateRef<any>;
  @ViewChild('modalRR', { static: false }) modalRR: TemplateRef<any>;
  @ViewChild('modalRepair', {static: false}) modalRepair: TemplateRef<any>;
  @ViewChild('modalCancelAll', {static: false}) modalCancelAll: TemplateRef<any>;
  @ViewChild('modalSelectCancel', {static: false}) modalSelectCancel: TemplateRef<any>;
  @ViewChild('selectActionModal', {static: false}) selectActionModal: TemplateRef<any>;
  @ViewChild('modalDamageReportDetails', { static: false }) modalDamageReportDetails: TemplateRef<any>;
  @ViewChild('modalRRDetails', { static: false }) modalRRDetails: TemplateRef<any>;
  @ViewChild('modalRCDetails', { static: false }) modalRCDetails: TemplateRef<any>;
  
  userSelectsString = '';
  userSelects = [];
  show: boolean = false;

  repair_request_Count=0;
  selectedDamage = [];

  request_pairings_rows=[];
  getData=[];
  getPair=[];
  requestID:any;
  cancelRequests:any;
  chooseToCancel:any;
  repairDone=0;
  cancelData=[];
  selectRows = [];

  constructor(private http: HttpClient, private modal: NgbModal, private _fb: FormBuilder,
    private maintenanceService: MaintenanceService, private fileService: FilesService,
    private taskService: TaskService, private toastr: ToastrService, private exporter: ExportService) {
  }

  showFilters: boolean = false;

  filterRepairRequestProvider: string = '';
  filterRepairRequestStatus: string = '';
  filterRepairRequestRego: string = '';
  filterRepairRequestDateFrom: Date;
  filterRepairRequestDateTo: Date;

  filterDamageReportStatus: string = '';
  filterDamageReportRego: string = '';
  filterDamageReportDateFrom: Date;
  filterDamageReportDateTo: Date;

  isFilterEmpty: boolean = true;
  tempRepairRequests = [];
  tempDamageReports = [];

  fullRowsRepairRequests = [];
  fullRowsDamageReports = [];

  repairRequestCount = 0;
  damageReportCount = 0;
  repairPairingCount = 0;

  show_requests: boolean = false;
  show_reports: boolean = true;

  oldFile1: any;
  oldFile2: any;
  oldFile3: any;
  oldFile4: any;
  oldFile5: any;
  oldFile6: any;
  oldFile7: any;
  oldFile8: any;
  oldFile9: any;
  oldFile10: any;

  fileExists1: boolean = false;
  fileExists2: boolean = false;
  fileExists3: boolean = false;
  fileExists4: boolean = false;
  fileExists5: boolean = false;
  fileExists6: boolean = false;
  fileExists7: boolean = false;
  fileExists8: boolean = false;
  fileExists9: boolean = false;
  fileExists10: boolean = false;

  dateNow:any;

  ngOnInit() {
    this.dateNow = new Date().toLocaleString();
    this.initRepairRequestForm();
    this.initRepairRequestFormChanges();
    this.initDamageReportForm();
    this.initRepairForm();
    this.initPairingForm();
    this.resetFileVariables();
    this.http.get(this.url.rest + '/tms/getMaintenanceMisc').toPromise().then(data => { 
      this.drivers = data["drivers"];
      this.fleet = data["fleet"];
      this.providers = data["providers"];
      this.repair_request_statuses = data["repair_request_statuses"];
      for (let status of this.repair_request_statuses){
        if (status.id < 3){
          this.rrq_status.push(status);
        }
      }
      this.report_statuses = data["report_statuses"];
      this.ratings = data['ratings'];
      
    });
    this.exp_excel = { title: '', list_data: '', type: '' };
    this.exp_pdf = { title: '', list_data: '', type: '' };
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes['requests']) {
      this.loading_indicator2 = true; 
      this.loading_indicator4 = true;
      this.request_rows = changes['requests'].currentValue;
      this.repairRequestCount = Object.keys(this.request_rows).length;
      this.fullRowsRepairRequests = this.request_rows;
      this.fullRR_Rows =  this.request_rows;
      this.tempRepairRequests = this.request_rows;
      if (this.request_rows.length) {
        this.selected2 = [this.request_rows[0]];
        
        if (this.selected2.length) {
          this.getTasksByRepairRequestId();
        }
      }

      else {
        this.selected2 = [];
        this.repairRequestCount = 0
      };

      if(this.fleet_id){
        console.log('fleet', this.fleet_id);
        this.maintenanceService.getPairingsById(this.fleet_id).toPromise().then(data=>{
          this.request_pairings_rows = data['pairing']
          this.fullRC_Rows = data['pairing']
          this.repairPairingCount = Object.keys(this.request_pairings_rows).length;
       
          if (this.request_pairings_rows.length) {
            this.selected4 = [this.request_pairings_rows[0]];
            if (this.selected4.length) {
            }
          }
          else {
            this.selected4 = [];
            this.repairPairingCount = 0
          }
  
          setTimeout(() => {this.loading_indicator2 = false; this.loading_indicator4 = false }, 500); 
          
        })
      }
      
    }

    if (changes['damages']) {
      this.request_rows = this.requests;
      this.loading_indicator3 = true;
      if (this.request_rows.length > 0 && this.request_rows != null) {
        this.selected2 = [this.request_rows[0]];
        this.repairRequestCount = Object.keys(this.request_rows).length;
        this.getTasksByRepairRequestId();
      }
      this.fullRowsRepairRequests = this.request_rows;
      this.tempRepairRequests = this.request_rows;
  
      this.damage_rows = this.damages;
      this.selectRows = [];
      for (let damage of this.damage_rows){
        
        if (damage.status_id == 1){
          this.selectRows.push(damage);
        }
        
      }

      if (this.damage_rows.length > 0 && this.damage_rows != null) {
        this.selected3 = [this.damage_rows[0]];
        this.damageReportCount = Object.keys(this.damage_rows).length;
        this.getTasksByDamageReportId();
      }
  
      this.fullRowsDamageReports = this.damage_rows;
      this.tempDamageReports = this.damage_rows;
  
      for(let damage of this.damage_rows){
        if (damage.status_id == 1){
          this.repair_request_Count= this.repair_request_Count+1;
        }
      } 
      setTimeout(() => { this.loading_indicator3 = false; }, 500); 
    }
  }

  request_columns = [
    { prop: 'Date' },
    { prop: 'Rego' },
    { prop: 'fleet_type' },
    { prop: 'Description' },
    { prop: 'filename' },
  ];

  damage_columns = [
    { prop: 'Date' },
    { prop: 'Rego' },
    { prop: 'fleet_type' },
    { prop: 'Description' },
    { prop: 'File' },

  ];

  pairing_columns = [
    { prop: 'request_id' },
    { prop: 'description' },
    { prop: 'rating_name' },
    { prop: 'status_name' },
    { prop: 'driver_name' },
    { prop: 'file' }
  ];


  isCost() {
    const frmCtrl = (<any>this.repairForm);

    if (frmCtrl.controls.cost.valid)
      return true;
    else return false;
  }
  isMileage() {
    const frmCtrl = (<any>this.repairForm);

    if (frmCtrl.controls.mileage.valid)
      return true;
    else return false;
  }
  isHours() {
    const frmCtrl = (<any>this.repairForm);

    if (frmCtrl.controls.hours.valid)
      return true;
    else return false;
  }

  onSelect2({ selected }) {
    this.getTasksByRepairRequestId();
  }

  onActivate2(event) {
    console.log('Activate Event', event);
  }

  onSelect3({ selected }) {
    this.getTasksByDamageReportId();
  }

  onActivate3(event) {
    console.log('Activate Event', event);
  }

  onSelect4({ selected }) {
    console.log("SELECTED4",this.selected4);
  }

  onActivate4(event) {
    console.log('Activate Event', event);
  }

  public formatDate(inDate: string) {
    let formatedDate: Date;
    formatedDate = new Date(inDate.replace(/-/g, "/"));
    return formatedDate;
  }

  openDamageReportDetails(): void {
    this.modalRef = this.modal.open(this.modalDamageReportDetails, { size: 'sm', backdrop: 'static'});
  }

  openRRDetails(): void {
    this.modalRef = this.modal.open(this.modalRRDetails, { size: 'sm', backdrop: 'static'});
  }

  openRepairConsolidatedDetails(): void {
    this.modalRef = this.modal.open(this.modalRCDetails, { size: 'sm', backdrop: 'static'});
  }

  openDeleteObjModal(obj, caller, modalName): void {

    if (obj) {

      switch (caller) {
        case this.prefixRepairRequest: { this.repairRequest = obj; this.title = "Repair Request"; this.fileToDelete = obj.filename; break }
        case this.prefixDamageReport: { this.damageReport = obj; this.title = "Damage Report"; this.fileToDelete = obj.file; break }
        default: break;
      }
    }

    this.objToDelete = obj;
    this.modalRef = this.modal.open(modalName, { size: 'sm', backdrop: 'static' });
  }

  async deleteObj(objToDelete) {
    this.spinner = true;
    let caller;

    switch (this.title) {
      case 'Repair Request': { caller = this.prefixRepairRequest; break; };
      case 'Damage Report': { caller = this.prefixDamageReport; break; };
      default: { break; };
    }

    if (this.title == 'Repair Request') {
      if (objToDelete.filename != null && objToDelete.filename != '') {
        this.deleteFile(caller, objToDelete.filename);
      }
    } else {
      if (objToDelete.file != null && objToDelete.file != '') {
        this.deleteFile(caller, objToDelete.file);
      }
    }

    switch (caller) {
      case this.prefixRepairRequest: {
        await this.maintenanceService.deleteRepairRequest(objToDelete.id).toPromise().then(res => {
          this.toastr.success('', res["message"], {
            timeOut: 3000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
          this.modalRef.close();
          this.refreshData.emit();
        }, error => {
          this.toastr.error("Please try again.", "There was a problem with deleting the selected repair request record", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        }); break;
      }

      case this.prefixDamageReport: {
        this.deleteDamageReport(objToDelete.id);

        break;
      }
      default: { break; };
    }
    this.refreshData.emit();
    this.modalRef.close();
    this.spinner = false;
    this.fileToDelete = '';
    this.selectRows = [];
  }

  public deleteFile(caller, filename) {
    this.fileService.deleteFile(caller, filename).subscribe(result => { console.log(result); })
    this.fileRemove = false;
    this.refreshData.emit();

  }

  print(elementId: string): void {
    let printContents, popupWin;
    printContents = document.getElementById(elementId).innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
        <html>
        <head>
        <title>Maintenance</title>
        <style>
        @page {
          size: A4;
        }

        table {
          border-collapse: collapse;
          border-spacing: 0;
          width: 100%;
          border: 1px solid #ddd !important;
      }

      th, td {
          text-align: left;
          padding: 16px;
      }


      tr:nth-child(even) {
          background-color: #f2f2f2 !important;
          box-shadow: inset 0 0 0 1000px #f2f2f2;
      }

      .fn {
        float: footnote;
      }

      thead {
        box-shadow: inset 0 0 0 1000px #f2f2f2;
      }
                
      </style>
      </head>
      <body onload="window.print();window.close()">${printContents}</body>
        </html>`
    );
    popupWin.document.close();
  }

  //file functions

  public getFile(event, caller) {

    var imgFilename;

    if (event == '' || event == null) {
      imgFilename = event
    } else {
      var file: ImageResult;
      file = event;
      imgFilename = file.file.name;

      this.frmFile = event;
    }

    switch (caller) {
      case this.prefixRepairRequest:
        { this.repairRequestForm.controls.filename.setValue(imgFilename); break; };
      case this.prefixDamageReport:
        { this.damageReportForm.controls.file.setValue(imgFilename); break; };
      default: break;
    }
  }

  public uploadFile(caller, filename) {
    if (this.frmFile) {
      this.fileService.uploadRawFile(caller, this.frmFile, filename).subscribe(file => {
        console.log('file uploaded....');
      });
    }

    this.frmFile = '';

    //handling files if replaced, old file is removed from server
    if (this.fileRemove == true) {
      this.deleteFile(caller, this.oldFile);
    };
  }

  public resetFileVariables() {
    // for document file handling variables; checking if file exists or removed
    this.fileExists = false;
    this.fileRemove = false;
    this.oldFile = '';
  }

  public removeFile(caller) {
    this.fileExists = false;

    switch (caller) {
      case this.prefixRepairRequest:
        { this.repairRequestForm.controls.filename.setValue(''); break; };
      case this.prefixDamageReport:
        { this.damageReportForm.controls.file.setValue(''); break; };
      default: break;
    }
    this.fileRemove = true;
  }

  public toggleFilters() {
    if (this.showFilters) this.showFilters = false;
    else this.showFilters = true;
  }

  public toggleFilters2() {
    if (this.showFilters2) this.showFilters2 = false;
    else this.showFilters2 = true;
  }

  toggleSideBar() {
    if (this.showSidebar == true) {
      this.loading_indicator3 = true;
      this.loading_indicator2 = true;
      this.loading_indicator4 = true;
      this.showSidebar = false;
      setTimeout(() => { this.loading_indicator2 = false; this.loading_indicator3 = false; this.loading_indicator4 = false; }, 100);
    } else {
      this.loading_indicator3 = true;
      this.loading_indicator2 = true;
      this.showSidebar = true;
      setTimeout(() => { this.loading_indicator2 = false; this.loading_indicator3 = false; this.loading_indicator4 = false; }, 100);
    }

  }

  toggleSideBar2() {
    if (this.showSidebar2 == true) {
      this.loading_indicator3 = true;
      this.loading_indicator2 = true;
      this.loading_indicator4 = true;
      this.showSidebar2 = false;
      setTimeout(() => { this.loading_indicator2 = false; this.loading_indicator3 = false; this.loading_indicator4 = false; }, 100);
    } else {
      this.loading_indicator3 = true;
      this.loading_indicator2 = true;
      this.showSidebar2 = true;
      setTimeout(() => { this.loading_indicator2 = false; this.loading_indicator3 = false; this.loading_indicator4 = false; }, 100);
    }

  }

  updateFilter(caller) {
    this.isFilterEmpty = false;

    switch (caller) {
      case this.prefixRepairRequest: {

        this.tempRepairRequests = this.fullRowsRepairRequests.filter(data => {
          if (this.filterRepairRequestStatus && data.status_id) {
            return data.status_id == this.filterRepairRequestStatus;
          } else {
            return data.status_id;
          }
        });

        this.tempRepairRequests = this.tempRepairRequests.filter(data => {
          if (this.filterRepairRequestRego && data.rego) {
            return data.rego.toLowerCase().indexOf(this.filterRepairRequestRego.toLowerCase()) !== -1 || !this.filterRepairRequestRego.toLowerCase();
          } else {
            return data.rego;
          }
        });

        this.tempRepairRequests = this.tempRepairRequests.filter(data => {
          if (data.date_submitted && (this.filterRepairRequestDateFrom && this.filterRepairRequestDateTo)) {
            return (new Date(data.date_submitted) >= new Date(this.filterRepairRequestDateFrom) && new Date(data.date_submitted) <= new Date(this.filterRepairRequestDateTo));
          } else {
            return data.date_submitted;
          };
        });

        this.request_rows = this.tempRepairRequests;
        this.repairRequestCount = Object.keys(this.tempRepairRequests).length;

        if (this.request_rows.length > 0) {
          this.selected2 = [this.request_rows[0]]
        } else {
          this.selected2 = [];
        }
      }

      case this.prefixDamageReport: {

        this.tempDamageReports = this.fullRowsDamageReports.filter(data => {
          if (this.filterStatus && data.status) {
            return data.status.toLowerCase().indexOf(this.filterStatus.toLowerCase() ) !== -1 || !this.filterStatus.toLowerCase();
          } else return data.status;  
        });

        this.tempDamageReports = this.tempDamageReports.filter(data => {
          if (this.filterDamageReportRego && data.rego) {
            return data.rego.toLowerCase().indexOf(this.filterDamageReportRego.toLowerCase()) !== -1 || !this.filterDamageReportRego.toLowerCase();
          } else {
            return data.rego;
          }
        });

        this.tempDamageReports = this.tempDamageReports.filter(data => {
          if (data.date_submitted && (this.filterDamageReportDateFrom && this.filterDamageReportDateTo)) {
            return (new Date(data.date_submitted) >= new Date(this.filterDamageReportDateFrom) && new Date(data.date_submitted) <= new Date(this.filterDamageReportDateTo));
          } else {
            return data.date_submitted;
          };
        });

        this.damage_rows = this.tempDamageReports;
        this.damageReportCount = Object.keys(this.tempDamageReports).length;

        if (this.damage_rows.length > 0) {
          this.selected3 = [this.damage_rows[0]]
        } else {
          this.selected3 = [];
        }
      }
      default: { break; }
    }
  }

  public resetFilters(caller) {
    if (caller == this.prefixRepairRequest) {
      this.filterRepairRequestProvider = '';
      this.filterRepairRequestDateFrom = null;
      this.filterRepairRequestDateTo = null;
      this.filterRepairRequestRego = '';
      this.filterRepairRequestStatus = '';

      this.request_rows = this.fullRowsRepairRequests;

      if (this.request_rows.length > 0) {
        this.selected2 = [this.request_rows[0]]
      } else {
        this.selected2 = [];
      }
    }

    if (caller == this.prefixDamageReport) {
      this.filterDamageReportRego = '';
      this.filterDamageReportStatus = '';
      this.filterDamageReportDateFrom = null;
      this.filterDamageReportDateTo = null;

      this.damage_rows = this.fullRowsDamageReports;
      if (this.damage_rows.length > 0) {
        this.selected3 = [this.damage_rows[0]]
      } else {
        this.selected3 = [];
      }
    }

    this.isFilterEmpty = true;
  }

  public modalClose() {
    this.fileExists = false;
    this.initDamageReportForm();
    this.fileExists1 = false;
    this.fileExists2 = false;
    this.fileExists3 = false;
    this.fileExists4 = false;
    this.fileExists5 = false;
    this.fileExists6 = false;
    this.fileExists7 = false;
    this.fileExists8 = false;
    this.fileExists9 = false;
    this.fileExists10 = false;
    this.modalRef.close();
    this.userSelects =[];
    this.show = false;
  }


  openMarkCompleteModal(modalMarkCompleted, prefix): void {
    this.setCaller(prefix);
    this.modalRef = this.modal.open(modalMarkCompleted, { container: '.app', size: 'sm', backdrop: 'static'});
  }

  async markCompleted(objectId, prefix) {
    this.spinner = true;
    //mark all task completed

    if (prefix == this.prefixRepairRequest) {
      await this.taskService.updateAllTaskCompletedByRepairRequestId(objectId).toPromise().then(result => {
        this.toastr.success('', result['message'], {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }, error => {
        this.toastr.error("Please try again.", "There was a problem with updating the completed task from the selected repair request", {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      });

      this.getTasksByRepairRequestId();
    } else {
      if (prefix == this.prefixDamageReport) {
        await this.taskService.updateAllTaskCompletedByDamageReportId(objectId).toPromise().then(result => {
          this.toastr.success('', result['message'], {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        }, error => {
          this.toastr.error("Please try again.", "There was a problem with updating the completed task from the selected damage report", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        });

        this.getTasksByDamageReportId();
      }
    };

    this.refreshData.emit();
    this.closeModal();
    this.spinner = false;
    this.selectRows = [];
  }

  public closeModal() {
    this.modalRef.close();
    this.modalCaller = null;
  }

  openPromptModal(modalName, task: Task, prefix) {
    this.setCaller(prefix);
    this.task = task;
    this.modalRef = this.modal.open(modalName, { container: '.app', size: 'sm' });
  }

  markTaskCompleted(taskId: number, prefix) {
    this.spinner = true;
    this.taskService.updateTaskCompleted(taskId).toPromise().then(result => {
      this.toastr.success('', result['message'], {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    }, error => {
      this.toastr.error("Please try again.", "There was a problem with updating the completed task", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });

    if (prefix == this.prefixRepairRequest) {
      this.getTasksByRepairRequestId();
    } else {
      if (prefix == this.prefixDamageReport) {
        this.getTasksByDamageReportId();
      }
    };

    this.refreshData.emit();
    this.closeModal();
    this.spinner = false;
    this.task = null;
    this.selectRows = [];
  }

  async deleteTask(taskId: number) {
    this.spinner = true;

    await this.taskService.deleteTask(taskId).toPromise().then(result => {
      this.toastr.success('', result['message'], {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    }, error => {
      this.toastr.error("Please try again.", "There was a problem with deleting the selected task", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });

    this.refreshData.emit();
    this.closeModalTask(this.caller);
    this.task = null;
    this.selectRows = [];
  }

  public action: string;
  openPromptModalTask(modalName, task: Task, objectId, prefix) {

    this.setCaller(prefix);

    if (task) {
      this.action = 'Edit';
    } else {
      this.action = 'Add';
    };

    this.task = task;

    if (prefix == this.prefixRepairRequest) {
      this.repairRequestId = objectId;
    } else {
      if (prefix == this.prefixDamageReport) {
        this.damageReportId = objectId;
      }

    }
    this.modalRef = this.modal.open(modalName, { size: 'lg', backdrop: 'static' });
  }

  public closeModalTask(prefix) {
    if (prefix == this.prefixRepairRequest) {
      this.getTasksByRepairRequestId();
    } else {
      if (prefix == this.prefixDamageReport) {
        this.getTasksByDamageReportId();
      }
    }

    this.refreshData.emit();
    this.spinner = false;
    this.closeModal();
    this.selectRows = [];
  }

  private setCaller(caller) {
    if (caller == this.prefixRepairRequest) {
      this.modalCaller = 'Repair Request';
      this.caller = this.prefixRepairRequest;
    } else {
      if (caller == this.prefixDamageReport) {
        this.modalCaller = 'Damage Report';
        this.caller = this.prefixDamageReport;
      }
      else { this.modalCaller = null };
    }
  }

  toggleReports(caller) {
    if (caller == 'requests') {
      this.show_requests = true;
      this.show_reports = false;
    } else {
      this.show_requests = false;
      this.show_reports = true;
    }

  }

  renameKey(obj, oldKey, newKey) {
    obj[newKey] = obj[oldKey];
    delete obj[oldKey];
  }

  //EXPORT LIST FOR REPAIR REQUESTS...

  generateRepairRequestHeaders(list_reports): any {
    const arr = JSON.parse(list_reports);
    arr.forEach(obj => {
      this.renameKey(obj, 'date_submitted', 'Date');
      this.renameKey(obj, 'rego', 'Rego');
      this.renameKey(obj, 'fleet_type', 'Fleet Type');
      this.renameKey(obj, 'subtype', 'Fleet Sub-Type');
      this.renameKey(obj, 'text', 'Description');
      this.renameKey(obj, 'filename', 'File');
    }
    );
    const updatedJson = JSON.stringify(arr);
    return updatedJson;
  }

  generateRepairRequestColumnsWithFilter(list_reports) {

    const arr = JSON.parse(JSON.stringify(list_reports));
    arr.forEach(obj => {

      //remove filtered columns
      if (!this.showRequestDate) {
        delete obj['date_submitted'];
      };
      if (!this.showRequestRego) {
        delete obj['rego'];
      };
      if (!this.showRequestFleetType) {
        delete obj['fleet_type'];
        delete obj['subtype'];
      };
      if (!this.showRequestDescription) {
        delete obj['text'];
      };
      if (!this.showRequestFile) {
        delete obj['filename'];
      };
      delete obj['id'];
      delete obj['time_submitted'];
      delete obj['rating_id'];
      delete obj['fleet_id'];
      delete obj['driver_id'];
      delete obj['driver_name'];
      delete obj['status_id'];
      delete obj['type_id'];
      delete obj['checklist_id'];
      delete obj['question_id'];
      delete obj['created_at'];
      delete obj['updated_at'];
      delete obj['status'];
      delete obj['rating'];
      delete obj['hour'];
      delete obj['minute'];
      delete obj['damageReportTaskCount'];
      delete obj['repair_id'];
      delete obj['repairRequestTaskCount'];
    });
    const updatedJson = JSON.stringify(arr);
    return updatedJson;
  }

  repairReq_exportToCSV() {
    if (this.request_rows.length > 0) {
      let with_header_format, with_column_filter;

      //generate json with filtered column
      with_column_filter = this.generateRepairRequestColumnsWithFilter(this.request_rows);

      //generate json with format header
      this.formatted_list = this.generateRepairRequestHeaders(with_column_filter);

      //export to file
      let current_date = new Date();
      let csv_file = '[TMS]Fleet_Maintenance_Repair_Requests_' + this.formattedDate(current_date);
      this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Fleet Maintenance - Repair Requests');
    }
  };

  repairReq_exportToPDF() {
    if (this.request_rows.length > 0) {
      let with_header_format, with_column_filter;

      //generate json with filtered column
      with_column_filter = this.generateRepairRequestColumnsWithFilter(this.request_rows);

      //generate json with format header
      this.formatted_list = this.generateRepairRequestHeaders(with_column_filter);

      //export to file
      let current_date = new Date();
      let pdf_file = '[TMS]Fleet_Maintenance_Repair_Requests_' + this.formattedDate(current_date);
      this.exp_pdf.title = 'REPAIR REQUESTS';
      this.exp_pdf.type = 'pdf';
      this.exp_pdf.list_data = this.formatted_list;
      this.exporter.exportToPDF(this.exp_pdf).subscribe(data => {
        saveAs(data, pdf_file + '.' + this.exp_pdf.type);
      });
    }
  };

  repairReq_exportToExcel() {
    if (this.request_rows.length > 0) {
      let with_header_format, with_column_filter;

      //generate json with filtered column
      with_column_filter = this.generateRepairRequestColumnsWithFilter(this.request_rows);

      //generate json with format header
      this.formatted_list = this.generateRepairRequestHeaders(with_column_filter);

      //export to file
      let current_date = new Date();
      let excel_file = '[TMS]Fleet_Maintenance_Repair_Requests_' + this.formattedDate(current_date);
      this.exp_excel.title = 'REPAIR REQUESTS';
      this.exp_excel.type = 'xlsx';
      this.exp_excel.list_data = this.formatted_list;
      this.exporter.exportToExcel(this.exp_excel).subscribe(data => {
        console.log(data);
        saveAs(data, excel_file)

      });
    }
  };
   //... END OF EXPORT LIST FOR REPAIR REQUESTS


  //EXPORT LIST FOR RRC...

  generateHeadersRRC(list_reports): any {
    const arr = JSON.parse(list_reports);
    arr.forEach(obj => {
      this.renameKey(obj, 'request_id', 'Request ID');
      this.renameKey(obj, 'description', 'Description');
      this.renameKey(obj, 'driver_name', 'Driver Name');
      this.renameKey(obj, 'rating_name', 'Rating');
      this.renameKey(obj, 'status_name', 'Status');
    }
    );
    const updatedJson = JSON.stringify(arr);
    return updatedJson;
  }

  generateColumnsWithFilterRRC(list_reports) {

    const arr = JSON.parse(JSON.stringify(list_reports));
    arr.forEach(obj => {
      //remove filtered columns
      if (!this.showPairingRequestID) {
        delete obj['request_id'];
      };
      if (!this.showPairingDesc) {
        delete obj['description'];
      };
      if (!this.showPairingDriver) {
        delete obj['driver_name'];
      };
      if (!this.showPairingRating) {
        delete obj['rating_name'];
      };
      if (!this.showPairingStatus) {
        delete obj['status_name'];
      };
      if (!this.showRepairConsolidated){
        delete obj['report_notification_id'];
      }
      delete obj['id'];
    });
    const updatedJson = JSON.stringify(arr);
    return updatedJson;
  }

  rrcReq_exportToCSV() {
      if (this.request_pairings_rows.length > 0) {
        let with_header_format, with_column_filter;
  
        //generate json with filtered column
        with_column_filter = this.generateColumnsWithFilterRRC(this.request_pairings_rows);
  
        //generate json with format header
        this.formatted_list = this.generateHeadersRRC(with_column_filter);
  
        //export to file
        let current_date = new Date();
        let csv_file = '[TMS]Fleet_Maintenance_Repair_Request_Consolidated' + this.formattedDate(current_date);
        this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Fleet Maintenance - Repair Request Consolidated');
      }
  };
  
  rrcReq_exportToPDF() {
      if (this.request_pairings_rows.length > 0) {
        let with_header_format, with_column_filter;
  
        //generate json with filtered column
        with_column_filter = this.generateColumnsWithFilterRRC(this.request_pairings_rows);
  
        //generate json with format header
        this.formatted_list = this.generateHeadersRRC(with_column_filter);
  
        //export to file
        let current_date = new Date();
        let pdf_file = '[TMS]Fleet_Maintenance_Repair_Request_Consolidated' + this.formattedDate(current_date);
        this.exp_pdf.title = 'REPAIR REQUESTS CONSOLIDATED';
        this.exp_pdf.type = 'pdf';
        this.exp_pdf.list_data = this.formatted_list;
        this.exporter.exportToPDF(this.exp_pdf).subscribe(data => {
          saveAs(data, pdf_file + '.' + this.exp_pdf.type);
        });
      }
  };
  
  rrcReq_exportToExcel() {
      if (this.request_pairings_rows.length > 0) {
        let with_header_format, with_column_filter;
  
        //generate json with filtered column
        with_column_filter = this.generateColumnsWithFilterRRC(this.request_pairings_rows);
  
        //generate json with format header
        this.formatted_list = this.generateHeadersRRC(with_column_filter);
  
        //export to file
        let current_date = new Date();
        let excel_file = '[TMS]Fleet_Maintenance_Repair_Request_Consolidated' + this.formattedDate(current_date);
        this.exp_excel.title = 'REPAIR REQUESTS CONSOLIDATED';
        this.exp_excel.type = 'xlsx';
        this.exp_excel.list_data = this.formatted_list;
        this.exporter.exportToExcel(this.exp_excel).subscribe(data => {
          console.log(data);
          saveAs(data, excel_file)
  
        });
      }
  }; 
  //... END OF EXPORT LIST FOR RRC...

  //EXPORT LIST FOR DAMAGE REPORTS...

  generateHeaders(list_reports): any {
    const arr = JSON.parse(list_reports);
    arr.forEach(obj => {
      this.renameKey(obj, 'date_submitted', 'Date');
      this.renameKey(obj, 'rego', 'Rego');
      this.renameKey(obj, 'fleet_type', 'Fleet Type');
      this.renameKey(obj, 'text', 'Description');
      this.renameKey(obj, 'file', 'File');
      this.renameKey(obj, 'location', 'Location');
    }
    );
    const updatedJson = JSON.stringify(arr);
    return updatedJson;
  }

  generateColumnsWithFilter(list_reports) {

    const arr = JSON.parse(JSON.stringify(list_reports));
    arr.forEach(obj => {
      //Merge Fleet type and its subtype in the list
      obj['fleet_type'] = obj['fleet_type'] + ' - ' + obj['subtype'];

      //Format date
      obj['date_submitted'] = formatDate(obj['date_submitted'], 'dd MMM yyyy', 'en_US');

      //remove filtered columns
      if (!this.showDate) {
        delete obj['date_submitted'];
      };
      if (!this.showRego) {
        delete obj['rego'];
      };
      if (!this.showFleetType) {
        delete obj['fleet_type'];
      };
      if (!this.showDescription) {
        delete obj['text'];
      };
      if (!this.showFile) {
        delete obj['file'];
      };
      delete obj['id'];
      delete obj['time_submitted'];
      delete obj['rating_id'];
      delete obj['fleet_id'];
      delete obj['driver_id'];
      delete obj['driver_name'];
      delete obj['status_id'];
      delete obj['type_id'];
      delete obj['checklist_id'];
      delete obj['question_id'];
      delete obj['created_at'];
      delete obj['updated_at'];
      delete obj['status'];
      delete obj['rating'];
      delete obj['hour'];
      delete obj['minute'];
      delete obj['damageReportTaskCount'];
      delete obj['repair_id'];
      delete obj['filename'];
      delete obj['repairRequestTaskCount'];
      delete obj['subtype'];
      delete obj['type_report_id'];
      delete obj['file1'];
      delete obj['file2'];
      delete obj['file3'];
      delete obj['file4'];
      delete obj['file5'];
      delete obj['file6'];
      delete obj['file7'];
      delete obj['file8'];
      delete obj['file9'];
      delete obj['file10'];
    });
    const updatedJson = JSON.stringify(arr);
    return updatedJson;
  }

  damageRep_exportToCSV() {
    if (this.damage_rows.length > 0) {
      let with_header_format, with_column_filter;

      //generate json with filtered column
      with_column_filter = this.generateColumnsWithFilter(this.damage_rows);

      //generate json with format header
      this.formatted_list = this.generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();
      let csv_file = '[TMS]Fleet_Damage_Maintenance_Reports_' + this.formattedDate(current_date);
      this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Fleet Maintenance - Damage Reports');
    }
  };

  damageRep_exportToPDF() {
    if (this.damage_rows.length > 0) {
      let with_header_format, with_column_filter;

      //generate json with filtered column
      with_column_filter = this.generateColumnsWithFilter(this.damage_rows);

      //generate json with format header
      this.formatted_list = this.generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();
      let pdf_file = '[TMS]Fleet_Damage_Maintenance_Reports_' + this.formattedDate(current_date);
      this.exp_pdf.title = 'DAMAGE REPORTS';
      this.exp_pdf.type = 'pdf';
      this.exp_pdf.list_data = this.formatted_list;
      this.exporter.exportToPDF(this.exp_pdf).subscribe(data => {
        saveAs(data, pdf_file + '.' + this.exp_pdf.type);
      });
    }
  };

  damageRep_exportToExcel() {
    if (this.damage_rows.length > 0) {
      let with_header_format, with_column_filter;

      //generate json with filtered column
      with_column_filter = this.generateColumnsWithFilter(this.damage_rows);

      //generate json with format header
      this.formatted_list = this.generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();
      let excel_file = '[TMS]Fleet_Maintenance_Damage_Reports_' + this.formattedDate(current_date);
      this.exp_excel.title = 'DAMAGE REPORTS';
      this.exp_excel.type = 'xlsx';
      this.exp_excel.list_data = this.formatted_list;
      this.exporter.exportToExcel(this.exp_excel).subscribe(data => {
        console.log(data);
        saveAs(data, excel_file)

      });
    }
  }; 
  //... END OF EXPORT LIST FOR DAMAGE REPORTS...

  public formattedDate(d = new Date) {
    let month = String(d.getMonth() + 1);
    let day = String(d.getDate());
    const year = String(d.getFullYear());

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return `${day}/${month}/${year}`;
  }

  //FILTERING

  public processURLFilter(field_filter: string, key_filter:string){
    if (field_filter == 'status') {
      if (key_filter == '1') {
        this.filterStatus = 'Pending'
      }
      if (key_filter == '2') {
        this.filterStatus = 'Acknowledged'
      }
      if (key_filter == '3') {
        this.filterStatus = 'Done'
      }
      if (key_filter == '4') {
        this.filterStatus = 'Cancelled'
      }
    }
    this.updateRRFilter();
    this.updateRConsolicatedFilter();
    this.updateFilter(this.prefixDamageReport);
  }

  updateRRFilter(){
    this.isFilterEmpty = false;
    this.request_rows = this.fullRR_Rows;
    this.temp = this.fullRR_Rows;
   
    if (this.filterStatus) {
      this.temp = this.temp.filter(data => { 
          if (data.status){
            return data.status.toLowerCase().indexOf(this.filterStatus.toLowerCase() ) !== -1 || !this.filterStatus.toLowerCase();   
          }
          else return data.status;   
        });
      }
    
      this.repairRequestCount = Object.keys(this.request_rows).length;    
      this.request_rows = this.temp;
    
        if (this.request_rows.length > 0) {
          this.selectedRR = [this.request_rows[0]]
        } else {
          this.selectedRR = [];
        }  
  }

  updateRConsolicatedFilter(){
    this.isFilterEmpty = false;
    this.request_pairings_rows = this.fullRC_Rows;
    this.temp = this.fullRC_Rows;
   
    if (this.filterDriver) {
      this.temp = this.temp.filter(data => {
        if (data.driver_name && this.filterDriver) {
          return data.driver_name.toLowerCase().indexOf(this.filterDriver.toLowerCase()) !== -1 || !this.filterDriver.toLowerCase();
        } else {
          return data.driver_name
        };
      });
    }

    if (this.filterDescription) {
      this.temp = this.temp.filter(data => {
        if (data.description && this.filterDescription) {
          return data.description.toLowerCase().indexOf(this.filterDescription.toLowerCase()) !== -1 || !this.filterDescription.toLowerCase();
        } else {
          return data.description
        };
      });
    }

    if (this.filterStatus) {
      this.temp = this.temp.filter(data => { 
          if (data.status_name && this.filterStatus){
            return data.status_name.toLowerCase().indexOf(this.filterStatus.toLowerCase() ) !== -1 || !this.filterStatus.toLowerCase();   
          }
          else return data.status_name;   
        });
      }
    
      this.repairPairingCount = Object.keys(this.request_pairings_rows).length;    
      this.request_pairings_rows = this.temp;
    
        if (this.request_pairings_rows.length > 0) {
          this.selectedRC = [this.request_pairings_rows[0]]
        } else {
          this.selectedRC = [];
        }  
  }

  onClickRRStatus(status) {
    this.filterStatus = status;
    this.updateRRFilter();
  }

  onClickRCStatus(status) {
    this.filterStatus = status;
    this.updateRConsolicatedFilter();
  }

  onClickDamageReport(status) {
    this.filterStatus = status;
    this.updateFilter(this.prefixDamageReport);
  }

  public resetRCFilters(){
    this.filterDriver = '';
    this.filterDescription = '';
    this.filterStatus = '';
    this.repairPairingCount = Object.keys(this.request_pairings_rows).length;

    this.request_pairings_rows = this.fullRC_Rows;
    this.repairPairingCount = Object.keys(this.request_pairings_rows).length;
    this.isFilterEmpty = true;
  }


//MULTI-SELECT (REPAIR_REQUESTS)
  suggest() {
    this.show = true;
  }

  closeRR() {
    this.show = false;
  }

  isSelected(s:any) {
   return this.userSelects.findIndex((item) => item.id === s.id) > -1 ? true : false;
  }

  selectSuggestion(s) {
    this.userSelects.find((item) => item.id === s.id) ? 
    this.userSelects = this.userSelects.filter((item) => item.id !== s.id) :
    this.userSelects.push(s);
    this.assignToNgModel()
  }

  deleteSelects(s) {
    this.userSelects = this.userSelects.filter((item) => item.id !== s.id);
    this.assignToNgModel();
  }

  assignToNgModel() {
    this.userSelectsString = '';
    this.userSelects.map((item) => console.log(item));
    
    if(this.userSelects.length != 0){
      this.repairRequestFormChanges.controls.repairRequestPairing.setValue(this.userSelects);
    }
    else{
      this.repairRequestFormChanges.controls.repairRequestPairing.setValue('');
    }
  }

  //DAMAGE REPORT

  initDamageReportForm() {
    this.damageReportForm = this._fb.group({
      id: [''],
      date_submitted: ['', Validators.required],
      time_submitted: [''],
      time_string: [{ hour: 1, minute: 30 }, Validators.required],
      fleet_id: ['', Validators.required],
      rating_id: ['', Validators.required],
      file: [''],
      status_id: [''],
      text: ['', Validators.required],
      checklist_id: [''],
      driver_id: ['', Validators.required],
      driver_name: [''],
      question_id: [''],
      location:['',Validators.required],
      file1: ['', Validators.required],
      file2: [''],
      file3: [''],
      file4: [''],
      file5: [''],
      file6: [''],
      file7: [''],
      file8: [''],
      file9: [''],
      file10: [''],
      fileCount: [''],
    });
  }

  openDamageReportModal(damageReport: DamageReport): void {
    if (damageReport) {
      console.log("damage report", damageReport)
      this.isEditMode = true;
      this.damageReport = damageReport;
      this.damageReport['time_string'] = { hour: this.damageReport['hour'], minute: this.damageReport['minute'] };
      this.damageReportForm.patchValue(this.damageReport);

      if (this.damageReport.file !== null && this.damageReport.file !== '') {
        this.oldFile = this.damageReport.file;
        this.fileExists = true;
      };

      if (this.damageReport.file1 !== null && this.damageReport.file1 !== '') {
        this.oldFile1 = this.damageReport.file1;
        this.fileExists1 = true;
      };

      if (this.damageReport.file2 !== null && this.damageReport.file2 !== '') {
        this.oldFile2 = this.damageReport.file2;
        this.fileExists2 = true;
      };

      if (this.damageReport.file3 !== null && this.damageReport.file3 !== '') {
        this.oldFile3 = this.damageReport.file3;
        this.fileExists3 = true;
      };

      if (this.damageReport.file4 !== null && this.damageReport.file4 !== '') {
        this.oldFile4 = this.damageReport.file4;
        this.fileExists4 = true;
      };

      if (this.damageReport.file5 !== null && this.damageReport.file5 !== '') {
        this.oldFile5 = this.damageReport.file5;
        this.fileExists5 = true;
      };

      if (this.damageReport.file6 !== null && this.damageReport.file6 !== '') {
        this.oldFile6 = this.damageReport.file6;
        this.fileExists6 = true;
      };

      if (this.damageReport.file7 !== null && this.damageReport.file7 !== '') {
        this.oldFile7 = this.damageReport.file7;
        this.fileExists7 = true;
      };

      if (this.damageReport.file8 !== null && this.damageReport.file8 !== '') {
        this.oldFile8 = this.damageReport.file8;
        this.fileExists8 = true;
      };

      if (this.damageReport.file9 !== null && this.damageReport.file9 !== '') {
        this.oldFile9 = this.damageReport.file9;
        this.fileExists9 = true;
      };

      if (this.damageReport.file10 !== null && this.damageReport.file10 !== '') {
        this.oldFile10 = this.damageReport.file10;
        this.fileExists10 = true;
      };

    }
    else {
      this.isEditMode = false;
      this.damageReport = new DamageReport();
      this.damageReportForm.reset();

      var fleet_value = '';
      if (this.fleet_id) { fleet_value = this.fleet_id.toString(); };
      this.damageReportForm.controls.fleet_id.setValue(fleet_value);
    }
    this.modalRef = this.modal.open(this.modalDamageReport, { size: 'lg', backdrop: 'static'});

    this.modalRef.result.then((result) => {
      this.damageReportForm.reset();
    }, (reason) => {
      this.damageReportForm.reset();
    });
  }

  async onSubmitDamageReport(damageReport: DamageReport) {

    this.spinner = true;
    this.damageReport = damageReport;
    this.damageReport['time_submitted'] = this.damageReport['time_string'].hour + ":" + this.damageReport['time_string'].minute + ":00";

    if (this.damageReportForm.valid) {

      if (damageReport.id) {

        if (damageReport.file1 != null) {
          damageReport.fileCount = 1;
        }

        if (damageReport.file2 != null) {
          damageReport.fileCount = 2;
        }

        if (damageReport.file3 != null) {
          damageReport.fileCount = 3;
        }

        if (damageReport.file4 != null) {
          damageReport.fileCount = 4;
        }

        if (damageReport.file5 != null) {
          damageReport.fileCount = 5;
        }

        if (damageReport.file6 != null) {
          damageReport.fileCount = 6;
        }

        if (damageReport.file7 != null) {
          damageReport.fileCount = 7;
        }

        if (damageReport.file8 != null) {
          damageReport.fileCount = 8;
        }

        if (damageReport.file9!= null) {
          damageReport.fileCount = 9;
        }

        if (damageReport.file10 != null) {
          damageReport.fileCount = 10;
        }

        await this.maintenanceService.updateDamageReportSample(damageReport).toPromise().then(res => {
          this.toastr.success('', res["message"], {
            timeOut: 3000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        }).catch(err => {
          this.toastr.error("Please try again.", "There was a problem with updating the selected damage report", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        });
        this.repair_request_Count = 0;
      }
      else {
        if ( this.imageFiles.length > 10){
        
          this.toastr.error('You have reached the maximum allowed number of images!', "Please try again. Until 10 images are only allowed!", {
          timeOut: 3000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      } else {
        damageReport.status_id = 1;
        await this.maintenanceService.createDamageReportSample(damageReport).toPromise().then(res => {
          this.toastr.success('', res["message"], {
            timeOut: 3000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        }).catch(err => {
          this.toastr.error("Please try again.", "There was a problem with creating new damage report", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        });
        console.log('creating damage report...');
      }
    }
      this.uploadFile(this.prefixDamageReport, this.damageReport.file);
      this.modalRef.close();
      this.spinner = false;
      this.refreshData.emit();
      this.selectRows = [];
    }
  }

  public getTasksByDamageReportId() {
    if (this.selected3) {
      this.taskService.getTasksByDamageReportId(this.selected3[0].id).subscribe(result => {
        this.tasksByDamageReportId = result['tasks'];
        if (typeof this.tasksByDamageReportId != "undefined"  && this.tasksByDamageReportId != null  
        && this.tasksByDamageReportId.length != null  && this.tasksByDamageReportId.length > 0) {
          this.selectedDamage = [this.tasksByDamageReportId[0]];
        }  
        else{
          this.selectedDamage=[];
        }
        setTimeout(() => { this.loadingIndicator = false; }, 1500);
        console.log("task by", this.tasksByDamageReportId.length)
      })
    }
  }

  async createDamageReport(damageReport: DamageReport) {
    this.spinner = true;
    await this.maintenanceService.createDamageReport(damageReport).toPromise().then(damageReport => {
    });
    this.spinner = false;
  }

  async updateDamageReport(damageReport: DamageReport) {
    this.spinner = true;
    await this.maintenanceService.updateDamageReport(damageReport).toPromise().then(damageReport => {
    });
    this.spinner = false;
  }

  async deleteDamageReport(id: number) {
    this.spinner = true;
    await this.maintenanceService.deleteDamageReport(id).toPromise().then(res => {
      this.toastr.success('', res["message"], {
        timeOut: 3000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });

      console.log('deleting damage Report')
    }).catch(err => {
      this.toastr.error("Please try again.", "There was a problem with deleting the selected damage report", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });
    this.modalRef.close();
    this.spinner = false;
    this.selectRows = [];
    this.refreshData.emit();
  }

  // REPAIR REQUEST

  initRepairRequestForm() {
    this.repairRequestForm = this._fb.group({
      id: [''],
      date_submitted: ['', Validators.required],
      time_submitted: [''],
      time_string: [{ hour: 1, minute: 30 }, Validators.required],
      text: ['', Validators.required],
      fleet_id: ['', Validators.required],
      rating_id: ['', Validators.required],
      status_id: [''],
      repair_id: [''],
      driver_id: [''],
      driver_name: [''],
      checklist_id: [''],
      question_id: [''],
      filename: [''],
    });
  }

  initRepairRequestFormChanges() {
    this.repairRequestFormChanges = this._fb.group({
      id: [''],
      date_submitted: ['', Validators.required],
      time_submitted: [''],
      time_string: [{ hour: 1, minute: 30 }, Validators.required],
      text: ['', Validators.required],
      fleet_id: ['', Validators.required],
      rating_id: [''],
      status_id: ['', Validators.required],
      repair_id: [''],
      driver_id: [''],
      driver_name: [''],
      checklist_id: [''],
      question_id: [''],
      filename: [''],
      repairRequestPairing: ['', Validators.required]
    });
  }

  openRepairRequestModal(repairRequest: RepairRequest): void {
    if (repairRequest) {
      this.isEditMode = true;
      this.repairRequest = repairRequest;
      this.repairRequest['time_string'] = { hour: this.repairRequest['hour'], minute: this.repairRequest['minute'] };
      this.repairRequestForm.patchValue(this.repairRequest);

      if (this.repairRequest.filename !== null && this.repairRequest.filename !== '') {
        this.oldFile = this.repairRequest.filename;
        this.fileExists = true;
      };
    }
    else {
      this.isEditMode = false;
      this.repairRequest = new RepairRequest();
      this.repairRequestForm.reset();

      var fleet_value = '';
      if (this.fleet_id) { fleet_value = this.fleet_id.toString(); };
      this.repairRequestForm.controls.fleet_id.setValue(fleet_value);
    }
    this.modalRef = this.modal.open(this.modalRepairRequest, { size: 'lg', backdrop: 'static'});

    this.modalRef.result.then((result) => {
      this.repairRequestForm.reset();
    }, (reason) => {
      this.repairRequestForm.reset();
    });
  }

  openRRModal(repairRequestChanges: RepairRequestChange): void {

    if (repairRequestChanges) {
      this.isEditMode = true;
      this.getPair=[];
      this.maintenanceService.getRRPByID(repairRequestChanges.id).toPromise().then(data=>{
        this.getPair = data['pairing']
        this.repairRequestFormChanges.controls.repairRequestPairing.setValue(this.getPair)
      })
      this.repairRequestChanges = repairRequestChanges;
      this.repairRequestChanges['time_string'] = { hour: this.repairRequestChanges['hour'], minute: this.repairRequestChanges['minute'] };
      this.repairRequestFormChanges.patchValue(this.repairRequestChanges);
      
      if (this.repairRequestChanges.filename !== null && this.repairRequestChanges.filename !== '') {
        this.oldFile = this.repairRequestChanges.filename;
        this.fileExists = true;
      };
    }
    else{
    this.isEditMode = false;
    this.repairRequestChanges = new RepairRequestChange();
    this.repairRequestFormChanges.reset();

    var fleet_value = '';
    if (this.fleet_id) { fleet_value = this.fleet_id.toString(); };
    this.repairRequestFormChanges.controls.fleet_id.setValue(fleet_value);
    }
    
    this.modalRef = this.modal.open(this.modalRR, { size: 'lg', backdrop: 'static'});
  }

  public getTasksByRepairRequestId() {
    if (this.selected2) {
      this.taskService.getTasksByRepairRequestId(this.selected2[0].id).subscribe(result => {
        this.tasksByRepairRequestId = result['tasks'];
      })
    }
  }

  async onSubmitRepairRequest(repairRequest: RepairRequest) {
    this.spinner = true;
    this.repairRequest = repairRequest;
    this.repairRequest['time_submitted'] = this.repairRequest['time_string'].hour + ":" + this.repairRequest['time_string'].minute + ":00";


    if (this.repairRequestForm.valid) {

      if (repairRequest.id) {

        await this.maintenanceService.updateRepairRequest(repairRequest).toPromise().then(res => {
          this.toastr.success('', res["message"], {
            timeOut: 3000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        }).catch(err => {
          this.toastr.error("Please try again.", "There was a problem with updating the selected repair request", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        });
        console.log('updating repair...');
      }
      else {
        await this.maintenanceService.createRepairRequest(repairRequest).toPromise().then(res => {
          this.toastr.success('', res["message"], {
            timeOut: 3000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });

        }).catch(err => {
          this.toastr.error("Please try again.", "There was a problem with creating new repair request entry", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        });
        console.log('creating repair request...');
      }

      this.uploadFile(this.prefixRepairRequest, this.repairRequest.filename);
      this.modalRef.close();
      this.spinner = false;
      this.refreshData.emit();
      this.selectRows = [];
    }
  }

  async onSubmitRepairRequestChanges(repairRequestChanges: RepairRequestChange) {
    this.spinner = true;
    this.repairRequestChanges = repairRequestChanges;
    this.repairRequestChanges['time_submitted'] = this.repairRequestChanges['time_string'].hour + ":" + this.repairRequestChanges['time_string'].minute + ":00";

      if (repairRequestChanges.id) {
        
        await this.maintenanceService.updateRepairRequestChanges(repairRequestChanges).toPromise().then(res => {
          this.toastr.success('', res["message"], {
            timeOut: 3000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        }).catch(err => {
          this.toastr.error("Please try again.", "There was a problem with updating the selected repair request", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        });
        console.log('updating repair...');
      }
      else {
        
        await this.maintenanceService.createRepairRequestChanges(repairRequestChanges).toPromise().then(res => {
          this.toastr.success('', res["message"], {
            timeOut: 3000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });

        }).catch(err => {
          this.toastr.error("Please try again.", "There was a problem with creating new repair request entry", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        });
        console.log('creating repair request...');
      }
     // this.uploadFile(this.prefixRepairRequest, this.repairRequest.filename);
      this.modalRef.close();
      this.userSelects=[];
      this.closeRR();
      this.spinner = false;
      this.refreshData.emit();
      this.selectRows = [];
  }

  async createRepairRequest(repairRequest: RepairRequest) {
    this.spinner = true;
    await this.maintenanceService.createRepairRequest(repairRequest).toPromise().then(repairRequest => {
    
    });
    this.spinner = false;
  }

  async updateRepairRequest(repairRequest: RepairRequest) {
    this.spinner = true;
    await this.maintenanceService.updateRepairRequest(repairRequest).toPromise().then(repairRequest => {
    });
    this.spinner = false;
  }

  async deleteRepairRequest(id: number) {
    this.spinner = true;
    await this.maintenanceService.deleteRepairRequest(id).toPromise().then(repairRequest => {
    });
    this.modalRef.close();
    this.refreshData.emit();
    this.selectRows = [];
    this.spinner = false;
  }
  
 
  initPairingForm() {
    this.cancelRequestPairingForm = this._fb.group({
      cancelPairing: ['',Validators.required],
    });
  }

  openCancelAllRequestsModal (): void {
    this.modalRef.close();
    this.objToCancel = this.chooseToCancel;
    this.modalRef = this.modal.open(this.modalCancelAll, { size: 'lg', backdrop: 'static' });
  }

  async cancelObj() {
    this.spinner = true;
    // switch (this.title) {
    //   case 'Repair Request': { caller = this.prefixRepairRequest; break; };
    //   case 'Damage Report': { caller = this.prefixDamageReport; break; };
    //   default: { break; };
    // }

    // if (this.title == 'Repair Request') {
    //   if (objToDelete.filename != null && objToDelete.filename != '') {
    //     this.deleteFile(caller, objToDelete.filename);
    //   }
    // } else {
    //   if (objToDelete.file != null && objToDelete.file != '') {
    //     this.deleteFile(caller, objToDelete.file);
    //   }
    // }
        await this.maintenanceService.cancelRepairRequest( this.chooseToCancel.id).toPromise().then(res => {
          this.toastr.success('', res["message"], {
            timeOut: 3000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        }, error => {
          this.toastr.error("Please try again.", "There was a problem with deleting the selected repair request record", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        }); 
    this.refreshData.emit();
    this.modalRef.close();
    this.closeModal();
    this.spinner = false;
    this.selectRows = [];
    // this.fileToDelete = '';
  }

  openSelectCancelObjModal(): void {
    this.modalRef.close();
    var ab = this.chooseToCancel;
    this.cancelRequests = [];
    this.maintenanceService.getDataById(ab.id).toPromise().then(data=>{
      this.cancelRequests = data['pairing']
    })
    this.modalRef = this.modal.open(this.modalSelectCancel, { size: 'lg', backdrop: 'static' });
  }

  async onSubmitCancelRequests(cancel: CancelPairing) {
    
    cancel.cancelPairing=this.cancelRequests;

    this.cancelRequests.forEach(i => {
      if (i.status_name == 'Cancel'){
        this.cancelData.push(i);
      }
    });

    cancel.cancelPairing = this.cancelData;
    this.spinner = true;
   
    await this.maintenanceService.cancelSelectedRepairRequest(cancel).toPromise().then(res => {
      this.toastr.success('', res["message"], {
        timeOut: 3000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    }).catch(err => {
      this.toastr.error("Please try again.", "There was a problem with cancelling the selected repair request", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });
    this.modalRef.close();
    this.spinner = false;
    this.cancelData=[];
    this.initPairingForm();
    this.refreshData.emit();
    this.selectRows = [];
  }

  openSelectAnAction(obj): void {
    this.chooseToCancel = obj;
    this.modalRef = this.modal.open(this.selectActionModal, { size: 'lg'});
  }

 
  updateCancelOptions(data,event){
  
    if(data.status_name == 'Acknowledged' || data.status_name == 'Pending'){
      data.status_name = 'Cancel';
    }
    else{
      data.status_name = 'Acknowledged';
    }

    this.selectCancelRequests = this.cancelRequests.length;

    this.cancelRequests.forEach(i => {
      if (i.status_name == 'Cancel'){
        this.selectCancelRequests = this.selectCancelRequests - 1;
      }
      else{
 
      }
    });

    if (this.cancelRequests.length != this.selectCancelRequests){
      this.cancelRequestPairingForm.controls.cancelPairing.setValue(this.cancelRequests);
    }
    else{
      this.cancelRequestPairingForm.controls.cancelPairing.setValue('');
    }

  }


  // REPAIR  

  initRepairForm() {
    const intRegex = '^[0-9]{1,11}$';
    const currencyRegex = '^[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$';
    const numbers = '^[0-9]+$'; 
    this.repairForm = this._fb.group({
      id: [''],
      date_done: ['', Validators.required],
      time_done: [''],
      time_string: [{hour: 1, minute: 30}],
      fleet_id: ['', Validators.required],
      fleet_report_id: [''],
      provider_id: ['', Validators.required],
      incident_id: [''],
      repair_description: ['', Validators.required],
      receipt_no: ['', Validators.required],
      cost: ['', [Validators.required, Validators.pattern(currencyRegex)]],
      mileage: ['', [Validators.required, Validators.pattern(numbers)]],
      hours:  ['', Validators.pattern(numbers)],
      fault: ['', Validators.required,],
      file: [''],
      note: [''],
      repair_request_id:[''],
      repairPairing:['', Validators.required]
    });
  }

  updateCheckedOptions(data,event){
    
    if(data.status_name == 'Acknowledged'){
      data.status_name = 'Done';
    }
    else{
      data.status_name = 'Acknowledged';
    }

    this.repairDone = this.getData.length
        
    this.getData.forEach(i => {
      if (i.status_name == 'Done'){
        console.log("each done",this.repairDone);
        
      }
      else{
        this.repairDone = this.repairDone -1;
      }
    });

    if (this.repairDone > 0){
      this.repairForm.controls.repairPairing.setValue(this.getData);
    }
    else{
      this.repairForm.controls.repairPairing.setValue('');
    }
  }

  openRepairModal(repair: Repair): void {
    this.getData=[];
    this.maintenanceService.getDataById(repair.id).toPromise().then(data=>{
      this.getData = data['pairing']
      
      if (this.getData.length > 0){
        this.requestID = this.getData[0].request_id
      }
    })
    this.repair = new Repair();
    //fleet_id is preset if come from fleetdetails component
    var fleet_value = '';
    if(this.fleet_id){fleet_value = this.fleet_id.toString();};
   this.repairForm.controls.fleet_id.setValue(fleet_value);

    this.modalRef = this.modal.open(this.modalRepair, { size: 'lg', backdrop: 'static'});

    this.modalRef.result.then((result) => {
      this.repairForm.reset();
    }, (reason) => {
      this.repairForm.reset();
    });
  }

  async onSubmitRepair(repair: Repair){
      this.spinner = true;
      this.repair = repair;
      if(this.repair['time_string'] != null){
        this.repair['time_done'] = this.repair['time_string'].hour + ":" + this.repair['time_string'].minute + ":00";
      }else{
        this.repair['time_done'] = '00:00:00'
      }
      if (this.repair['hours'] == null){
        this.repair['hours'] = 0
      }
      repair.repair_request_id = this.requestID;
      await this.maintenanceService.createRepairSample(repair).toPromise().then(res=> {
                this.toastr.success('', res["message"], {
                  timeOut: 5000,
                  positionClass: 'toast-top-full-width',
                  progressBar: true
                  });
            }).catch(err =>{
              this.toastr.error("Please try again.", "There was a problem with creating new repair record", {
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
              });
            });
      console.log('creating repair...');
      this.modalClose();
      this.refreshData.emit();   
      this.selectRows = [];
      this.spinner = false; 
  }

  getCellClass({ row, column, value }): any {
    return {
      'is-pending': row.status_id == '1',
      'is-completed': row.status_id == '3',
      'is-processing': row.status_id == '2',
      'is-cancelled': row.status_id == '4'
    };
  }

  getCellClass2({ row, column, value }): any {
    return {
      'is-pending': row.status_name== 'Pending',
      'is-completed': row.status_name == 'Done',
      'is-processing': row.status_name == 'Acknowledged',
      'is-cancelled': row.status_name == 'Cancelled'
    };
  }

  public getImages(event){
    this.imageFiles = event;
      for (let i =0; i < this.imageFiles.length;i++){
          if ( i == 0){
          this.damageReportForm.controls.file1.setValue(this.imageFiles[0].dataUrl);
          }
          else if ( i == 1){
            this.damageReportForm.controls.file2.setValue(this.imageFiles[1].dataUrl);
          }
         else if ( i == 2){
            this.damageReportForm.controls.file3.setValue(this.imageFiles[2].dataUrl);
          }
         else if ( i ==3){
            this.damageReportForm.controls.file4.setValue(this.imageFiles[3].dataUrl);
          }
         else if ( i == 4){
             this.damageReportForm.controls.file5.setValue(this.imageFiles[4].dataUrl);
          }
         else if ( i == 5){
             this.damageReportForm.controls.file6.setValue(this.imageFiles[5].dataUrl);
          }
         else if ( i == 6){
             this.damageReportForm.controls.file7.setValue(this.imageFiles[6].dataUrl);
          }
         else if ( i == 7){
              this.damageReportForm.controls.file8.setValue(this.imageFiles[7].dataUrl);
          }
         else  if ( i == 8){
             this.damageReportForm.controls.file9.setValue(this.imageFiles[8].dataUrl);
          }
         else if ( i == 9){
          this.damageReportForm.controls.file10.setValue(this.imageFiles[9].dataUrl);
          }
        
      }
    
    this.damageReportForm.controls.fileCount.setValue(this.imageFiles.length);
    
  }
  
}